import { render, staticRenderFns } from "./adminsec.vue?vue&type=template&id=30c93311&"
import script from "./adminsec.vue?vue&type=script&lang=js&"
export * from "./adminsec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports